export const INITIAL_STATE = 'INITIAL_STATE'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const VERIFY_ACCOUNT = 'VERIFY_ACCOUNT'
